import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification, showSuccessNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useClaimAttachmentsApi } from "../../http/claimAttachments/api";
import { ClaimAttachment } from "../../http/claimAttachments/types";
import ModalDialog from "../ui/ModalDialog";

type DeleteClaimAttachmentDialogProps = {
  claimAttachment: ClaimAttachment;
  onClose: () => void;
};

const DeleteClaimAttachmentDialog: FC<DeleteClaimAttachmentDialogProps> = ({ claimAttachment, onClose }) => {
  const i18n = useI18n();
  const claimAttachmentsApi = useClaimAttachmentsApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.documents.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            claimAttachmentsApi
              .deleteClaimAttachment(claimAttachment.id, claimAttachment.claim.id)
              .then(() => {
                onClose();
                dispatch(showSuccessNotification(i18n.t));
              })
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.documents.questions.delete}
    </ModalDialog>
  );
};

export default DeleteClaimAttachmentDialog;
